module.exports = __webpack_public_path__ + "static/media/TruckTrials.13afe78f.jpg";